export const assistantIsMobileBreakpoint = 800;
export const assistantMaxWidth = 800; // pixels
